import WIDGETS from './widgets';

export default {
	name: 'file_manage',
	spacing: 2,
	sx: { width: '100%' },
	widgets: [{ content: WIDGETS.FILE_MANAGE, breakpoints: { xs: 12, sm: 12 }, lazy_loading: 0 }],
};
